var map = {
	"./gallery1.png": 48750,
	"./gallery2.png": 75733,
	"./gallery3.png": 96553,
	"./gallery4.png": 5538,
	"./gallery5.png": 58395,
	"./gallery6.png": 3597,
	"./gallery7.png": 33674,
	"./gallery8.png": 36542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65491;